import { chakra, defineRecipe } from '@plurall/elo-v3';

const NAV_ICON_SURFACE = {
  backgroundColor: 'alpha.white.12',
  boxShadow: '0 0 0 1px {colors.alpha.white.22}',
} as const;

const appNavIconButtonRecipe = defineRecipe({
  className: 'app-nav-icon-button',
  base: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 'size.40',
    height: 'size.40',
    minWidth: 'size.40',
    minHeight: 'size.40',
    maxWidth: 'size.40',
    maxHeight: 'size.40',
    padding: 0,
    borderRadius: '50%',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: 'foreground.inverse',
    textDecoration: 'none',
    transition: 'background-color 150ms ease-in-out',

    _hover: NAV_ICON_SURFACE,
    _focusVisible: {
      ...NAV_ICON_SURFACE,
      outline: '2px solid',
      outlineColor: 'action.focus.ring.primary',
      outlineOffset: '2px',
    },
    _active: NAV_ICON_SURFACE,

    '&[aria-expanded="true"]': NAV_ICON_SURFACE,

    '& svg': {
      width: 'size.24',
      height: 'size.24',
      minWidth: 'size.24',
      minHeight: 'size.24',
      flexShrink: 0,
      display: 'block',
      pointerEvents: 'none',
    },
  },

  variants: {
    isActive: {
      true: NAV_ICON_SURFACE,
      false: {},
    },
  },

  defaultVariants: { isActive: false },
});

export const AppNavIconButtonFactory = chakra('button', appNavIconButtonRecipe);
